import { useShowToast } from '@globals/toaster/useToasterStore'
import { useT } from '@transifex/react'
import { useCallback } from 'react'

export const useCopyToClipboard = () => {
  const t = useT()
  const showToast = useShowToast()

  const copy = useCallback(
    (text: string) => {
      if (text) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(text)
            .then(() => {
              showToast({
                message: t('Copied to clipboard'),
                severity: 'success',
              })
            })
            .catch(() => {
              showToast({ message: t('Unable to copy to clipboard'), severity: 'error' })
            })
        } else {
          showToast({
            message: t('Copy to clipboard not supported on this device'),
            severity: 'info',
          })
        }
      }
    },
    [t, showToast],
  )
  return copy
}
